export type MobileTab = 'file' | 'editor';

export class MobileTabBar {
  private container: HTMLElement;
  private activeTab: MobileTab = 'file';
  private listeners: ((tab: MobileTab) => void)[] = [];

  public get currentTab(): MobileTab {
    return this.activeTab;
  }

  constructor(container: HTMLElement) {
    this.container = container;
    this.container.className = 'mobile-tab-bar';
    this.render();
  }

  onTabChange(listener: (tab: MobileTab) => void) {
    this.listeners.push(listener);
  }

  setActiveTab(tab: MobileTab) {
    this.activeTab = tab;
    this.render();
    this.listeners.forEach(l => l(tab));
  }

  private render() {
    this.container.innerHTML = '';

    const tabs: { id: MobileTab, label: string, icon: string }[] = [
      { id: 'file', label: 'File', icon: '📁' },
      { id: 'editor', label: 'Editor', icon: '📝' }
    ];

    tabs.forEach(tab => {
      const btn = document.createElement('button');
      btn.className = `mobile-tab ${this.activeTab === tab.id ? 'active' : ''}`;
      btn.innerHTML = `
        <div class="tab-icon">${tab.icon}</div>
        <div class="tab-label">${tab.label}</div>
      `;
      btn.onclick = () => this.setActiveTab(tab.id);
      this.container.appendChild(btn);
    });
  }
}
